
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]/wishlist/[product_slug]",
      function () {
        return require("private-next-pages/[username]/wishlist/[product_slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[username]/wishlist/[product_slug]"])
      });
    }
  